import React from 'react';
import AlertsEmpty from './style';
import noResult from '@core/ui/static/images/ico-sad.svg';

export default function Empty({ title, description, extra }) {
  return (
    <AlertsEmpty>
      <img src={noResult} alt="Aucun favoris" />
      {title && <h2>{title}</h2>}
      {description && <p>{description}</p>}
      {extra && <div>{extra}</div>}
    </AlertsEmpty>
  );
}
